var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('toolbar',[_c('h2',[_c('i',{staticClass:"fa fa-cubes"}),_vm._v("\n\t\t\tProjects Apps\n\t\t")]),_c('projects-toolbar-controls',{attrs:{"mobile-breakpoint":800}})],1),_c('addon-app-tab',{attrs:{"ui-location":"Projects Module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }